import Controller from '../abstracts/Controller';

export default class ProductController extends Controller {
  static get COMPONENTS() {
    return [
      //'ImageZoomComponent',
      'CartBarComponent',
      'NotifyMeComponent',
      'CarouselComponent',
      'TabsComponent',
      'SizeGuideComponent',
      'VideoComponent',
      'VideoBrightcove',
      'QuickBuyComponent',
      'ProductZoomComponent',
      'ProductOpenedComponent'
    ];
  }
}
